import { Page } from '@app/components/page/Page';
import { FleetModule } from '@app/modules/fleet';
import StreamerBoxIcon from '@app/modules/fleet/legacy/components/StreamerBoxIcon';
import { useIntl } from 'react-intl';
import { BalenaDevicesList } from './BalenaDevicesList';

/**
 * Fleet Balena devices listing page shell.
 */
export function BalenaDevicesListPage() {
  const { $t } = useIntl();
  const title = $t({
    id: 'fleet.devices.listScreen.title',
    defaultMessage: 'Devices',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header icon={FleetModule.icon ?? <StreamerBoxIcon />} title={title} />
      <BalenaDevicesList />
    </Page>
  );
}
